import { API_ROUTES } from '@memorai/routes';
import type { AnalyzeAudioParams, AnalyzeResponse } from '@memorai/types';
import { apiFetch } from './client.js';

export type { AnalyzeAudioParams, AnalyzeResponse } from '@memorai/types';

async function blobToBase64(blob: Blob): Promise<string> {
    const reader = new FileReader();
    const base64Promise = new Promise<string>((resolve, reject) => {
        reader.onloadend = () => {
            const base64 = (reader.result as string).split(',')[1];
            resolve(base64);
        };
        reader.onerror = reject;
    });

    reader.readAsDataURL(blob);
    return base64Promise;
}

export async function analyzeAudio(params: AnalyzeAudioParams): Promise<AnalyzeResponse> {
    const { audioBlob, language, profileId, durationSeconds, fileSizeBytes } = params;
    if (!audioBlob) throw new Error('Audio blob is required for initial analysis');

    const audioBase64 = await blobToBase64(audioBlob);

    return apiFetch<AnalyzeResponse>(API_ROUTES.ANALYZE, {
        method: 'POST',
        body: JSON.stringify({
            audio: audioBase64,
            mimeType: audioBlob.type || 'audio/webm',
            language,
            profile_id: profileId,
            duration_seconds: durationSeconds,
            file_size_bytes: fileSizeBytes,
        }),
    });
}

export async function appendToNote(id: string, params: AnalyzeAudioParams): Promise<AnalyzeResponse> {
    const { audioBlob, text, language, profileId, durationSeconds, fileSizeBytes } = params;

    let audioBase64: string | undefined;
    let mimeType: string | undefined;

    if (audioBlob) {
        audioBase64 = await blobToBase64(audioBlob);
        mimeType = audioBlob.type || 'audio/webm';
    }

    return apiFetch<AnalyzeResponse>(API_ROUTES.NOTE_APPEND(id), {
        method: 'POST',
        body: JSON.stringify({
            text,
            audio: audioBase64,
            mimeType,
            language,
            profile_id: profileId,
            duration_seconds: durationSeconds,
            file_size_bytes: fileSizeBytes,
        }),
    });
}

